import { createSubjectAttributes, ExperimentationProvider, Platform, ProjectName } from '@user-portal/experimentation';
import { FC, ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from 'store/user/selectors';

import { experimentationConfig } from './experimentationConfig';

interface ExperimentationWrapperProps {
    children: ReactNode;
}

export const ExperimentationWrapper: FC<ExperimentationWrapperProps> = ({ children }) => {
    const user = useSelector(selectCurrentUser);

    const subjectAttributes = useMemo(() => {
        const userId = user.user_id || 'anonymous';
        const userEmail = user.email || '';

        return createSubjectAttributes(userId, userId, {
            // Application information
            platform: Platform.WEB,
            w2a_branch: user.branch_name,
            source_project: ProjectName.WALKING,
            source_platform: Platform.WEB,

            // User properties
            country: user.country || undefined,
            gender: user.gender || undefined,
            age: user.age ? parseInt(user.age, 10) : undefined,
            height: user.height || undefined,
            weight: user.weight || undefined,
            scale: user.units || undefined,

            // Fitness specific
            fitness_level: user.fitness_level || undefined,
            goal: user.goal || undefined,
            target_weight: user.target_weight || undefined,
            is_active_plan: user.is_paid || false,
            problem_zones: user.target_zone || undefined,

            extras: {
                email: userEmail,
                source: 'walk-fit-portal',
            },
        });
    }, [user]);

    return (
        <ExperimentationProvider config={experimentationConfig} subjectAttributes={subjectAttributes}>
            {children}
        </ExperimentationProvider>
    );
};
